import { IClipboardOptions } from '@infragistics/igniteui-angular/grids/core';
import { enUS, fr, ja, Locale } from 'date-fns/locale';

import { environment } from '@Environment/environment';
import { measurementPointMarkData } from '@VineyardLib/data/measurement-point-mark-data';

export const MACHINE_TYPE = { SPRAYER: '1', WEEDER: '2' } as const;
export const MACHINE_CONDITION_TYPE = {
  NORMAL: '1',
  MALFUNCTION: '2',
  REPAIR: '3',
  OCCUPIED: '4',
} as const;
export const MACHINE_MESSAGE_TYPE = {
  ATTENTION: '1',
  WARNING: '2',
  STOP: '3',
  TEMPORARY_STOP: '4',
  TERMINAL: '5',
} as const;
export const OCCURRENCE_FLAG = {
  NOT_OCCURRENCE_FAILURE: '0',
  OCCURRENCE_FAILURE: '1',
} as const;
export const AUTO_ECU_MODE = {
  INIT: '0',
  MANUAL: '1',
  WORK_LIST_COPY: '2',
  PATH_COPY: '3',
  PRE_READY: '4',
  READY: '5',
  WAIT_START: '6',
  PRE_AUTO: '7',
  AUTO: '8',
  PRE_TEMPORARY_STOP: '9',
  TEMPORARY_STOP: '10',
  PRE_MANUAL: '11',
  EMERGENCY_STOP: '12',
  OFFLINE: '999',
} as const;
export const START_POSITION_CHANGE_FLG = {
  NO_CHANGE: '0',
  CHANGE: '1',
} as const;
export const MIME_TYPE = {
  IMAGE_APNG: '1',
  IMAGE_BMP: '2',
  IMAGE_GIF: '3',
  IMAGE_X_ICON: '4',
  IMAGE_JPEG: '5',
  IMAGE_PNG: '6',
  IMAGE_SVG_XML: '7',
  IMAGE_TIFF: '8',
  IMAGE_WEBP: '9',
} as const;
export const WORK_STATUS = {
  NOT_START: '1',
  PENDING: '2',
  IN_PROGRESS: '3',
  COMPLETED: '4',
  DELETED: '5',
  CANCELED: '6',
  DRAFT: '7',
} as const;
export const WORK_START_TYPE = {
  ANYTIME: '1',
  AM: '2',
  PM: '3',
  SPECIFY_TIME: '4',
} as const;
export const WORK_TYPE = {
  SPRAYING: '1',
  WEEDING_INTERCEPS: '2',
  WEEDING_INTER_ROWS: '3',
  HYDRAULIC_WEEDING_INTERCEPS: '4',
  HYDRAULIC_WEEDING_INTER_ROWS: '5',
} as const;
export const WORK_LIST_TYPE = {
  PREVIOUS_DAY: '1',
  CURRENT_DAY: '2',
  NEXT_DAY: '3',
} as const;
export const DOWNLOAD_STATUS = {
  WAIT_FOR_DOWNLOAD: '1',
  DOWNLOADING: '2',
  DOWNLOADED: '3',
  DOWNLOAD_ERROR: '4',
} as const;
export const START_MIDDLE_FLG = {
  NOT_START_MIDDLE: '0',
  START_IN_MIDDLE: '1',
} as const;
export const END_MIDDLE_FLG = {
  NOT_END_MIDDLE: '0',
  END_IN_MIDDLE: '1',
} as const;
export const DOWNLOAD_REQ_FLG = {
  NO_DOWNLOAD_REQUEST: '0',
  DOWNLOAD_REQUEST: '1',
} as const;
export const WORKPLAN_SAVE_STATUS = { NOT_SAVED: '0', SAVED: '1' } as const;
export const WORK_INSTRUCTION_TYPE = {
  BEGIN: '1',
  QUIT: '2',
  SUSPEND: '3',
} as const;
export const INSTRUCTION_STATUS = {
  WAIT_FOR_INSTRUCTION: '1',
  INSTRUCTING: '2',
  INSTRUCTED: '3',
  INSTRUCTION_ERROR: '4',
  CANCELED: '5',
} as const;
export const DEL_FLG = { NOT_DELETE: '0', DELETED: '1' } as const;
export const WORK_HISTORY_TYPE = { START: '1', END: '2' } as const;
export const MACHINE_STATUS = {
  INITIALIZING: '1',
  MANUAL_DRIVING: '2',
  AUTO_DRIVING: '3',
  PRE_TEMPORARY_STOP: '4',
  TEMPORARY_STOP: '5',
  STOP: '6',
  OFF_LINE: '7',
} as const;
export const OPERATION_RESULT = { FAILED: '0', SUCCESS: '1' } as const;
export const OPERATION_STATUS = {
  OPERATION_RECEIVE: '1',
  MACHINE_SEND: '2',
  MACHINE_RECEIVE: '3',
  MODE_SUCCESS: '4',
  OPERATION_FAIL: '5',
  NO_RESPONSE: '6',
  KEEP_RESPONSE: '7',
  KEEP_TIMEOUT: '8',
  NO_OPERATION: '9',
} as const;
export const SYNC_STATUS = { SYNC: '1', OUT_OF_SYNC: '2' } as const;
export const MIDDLE_FLG = { NOT_MIDDLE: '0', IN_MIDDLE: '1' } as const;
export const WORK_FLG = { NOTWORKING: '0', WORKING: '1' } as const;
export const RUN_MODE = { SEG: '1', TURN: '0' } as const;
export const RUN_AREA = {
  FP: '0',
  DR: '1',
  HN: '2',
  BEFORE_WORK: '3',
} as const;
export const TURN_TYPE = {
  LINE: '0',
  FISHTAILTURN: '1',
  HOOKTURN: '2',
  UTURN: '3',
  FLATTURN: '4',
  NAVIGATION: '5',
  SPIN: '6',
} as const;
export const DIRECTION_OF_TURN = {
  STRAIGHT: '-1',
  RIGHT: '0',
  LEFT: '1',
} as const;
export const RUN_DIRECTION = { FORWARD: '1', REVERSE: '0' } as const;
export const WORK_MODE = {
  OFF: '0',
  ON_INNER: '1',
  ON_LEFT: '2',
  ON_INNERLEFT: '3',
  ON_RIGHT: '4',
  ON_INNERRIGHT: '5',
  ON_LEFTRIGHT: '6',
  ON_ALL: '7',
} as const;
export const RUNNING_SPEED_TYPE = {
  WORKAREA_SPEED: '1',
  CURVE_SPEED: '2',
  HEADLAND_SPEED: '3',
} as const;
export const CAN_STOP_FLG = { PROHIBIT: '0', PERMIT: '1' } as const;
export const AUTO_END_MESSAGE_TYPE = {
  RUN_PATH_FINISHED: '1',
  CONTROL_SYSTEM_ERROR_CAN_HW_DM1: '4',
  CONTROL_SYSTEM_ERROR_LCD_MONITOR: '5',
  EMERGENCY_STOP_SWITCH: '6',
  EMERGENCY_STOP_REMOTE_CONTROLLER: '7',
  MANUAL_CONTROL_ERROR: '8',
  LOW_FUEL: '9',
  LOW_PUMP_FLOW_RATE: '10',
  PATH_DATA_ERROR: '11',
  GNSS_ERROR: '12',
  OUT_OF_FIELD_BOUNDS: '15',
  MACHINE_TILTED: '16',
  MANUAL_OPERATION: '18',
  ENGINE_STOP: '19',
  RAISE_LOWER_SWITCH_OPERATED: '20',
  EXPORT_CONST_LOW_FUEL_LEVEL_OF_HYD: '21',
  EXPORT_CONST_ENGINE_STOP_OF_HYD: '22',
} as const;
export const TEMPORARY_STOP_MESSAGE_TYPE = {
  LOW_GNSS_ACCURACY: '1',
  SUSPEND_OPERATION: '3',
  EMERGENCY_STOP_REMOTE_CONTROLLER_NOT_FOUND: '4',
  OBSTRUCTION_DETECTED: '5',
  TURN_TIME_OVER: '6',
  SLIP_RATE_OVER: '7',
  TEMPORARY_STOP_FROM_REMOTE_CONTROLLER: '8',
  SAFETY_SENSOR_ERROR: '9',
  LOW_PESTICIDE_LEVEL: '10',
  LATERAL_DEVIATION: '11',
  DIRECTIONAL_DEVIATION: '12',
  GETTING_PATH_DATA_FAILED: '13',
  EXPORT_CONST_FAILED_TO_GET_BACK_ON_THE_PATH: '14',
  EXPORT_CONST_CONTINUOUS_HIGH_PRESSURE_DETECTED: '15',
} as const;
export const TERMINAL_ERROR_TYPE = {
  ROUTE_FILE_CORRUPTION: '1',
  ROUTE_FILE_ERROR: '2',
  ROUTE_FILE_FORMAT_ERROR: '3',
  REQUEST_PATH_INDEX_ERROR: '4',
  TASK_LIST_FILE_ERROR: '5',
  CAN_CONNECTION_ERROR: '11',
  SERVER_COMMUNICATION_RECEPTION_DATA_ERROR: '12',
  TASK_LIST_FILE_CORRUPTION: '13',
  TASK_LIST_FILE_FORMAT_ERROR: '14',
  INITIAL_SETTING_ERROR: '15',
} as const;
export const MACHINE_INSTRUCTION_ERROR_TYPE = {
  INITIALIZING: '0',
  INVALID_SERVICE_REQUEST: '1',
  INVALID_SERVICE_REQUEST_FORMAT: '2',
  INVALID_SERVICE_REQUEST_PARAMETER: '3',
  WORKLIST_PROCESSING_OR_AUDO_DRIVING: '4',
  NOT_MANUAL_DRIVING: '17',
  RESET_REQUEST_ERROR: '18',
  DEFAULT_PATH_SEND_ERROR: '256',
  DEFAULT_PATH_SAVE_ERROR: '257',
  DEFAULT_PATH_INVALID_FORMAT: '258',
  WORKLIST_SEND_ERROR: '512',
  WORKLIST_SAVE_ERROR: '513',
  WORKLIST_INVALID_FORMAT: '514',
  MACHINE_RESPONSE_TIMEOUT: '32767',
} as const;
export const CONTRACT_CUSTOMER_TYPE = {
  CUSTOMER: '1',
  DEALER: '2',
  YANMARGROUP: '3',
} as const;
export const AP_TYPE = { VINEYARD_WEB: '1', VINEYARD_IOT: '2' } as const;
export const FIELD_MEASUREMENT_TYPE = {
  OUT: '1',
  PICKET: '2',
  MIDDLE: '3',
} as const;
export const SHIPPING_STATUS_TYPE = {
  BEFORE_INSPECTION: '1',
  INSPECTED: '2',
  SHIPPED: '3',
  IN_USE: '4',
  DEALERSTOCK: '5',
  NOT_IN_USE: '6',
} as const;
export const COORDINATE_FILE_FLG = { NOT_INCLUDED: '0', INCLUDE: '1' } as const;
export const WORK_SPEED_TYPE = {
  SPEED0_5KPH: '0',
  SPEED1_0KPH: '1',
  SPEED1_5KPH: '2',
  SPEED2_0KPH: '3',
  SPEED2_5KPH: '4',
  SPEED3_0KPH: '5',
  SPEED3_5KPH: '6',
  SPEED4_0KPH: '7',
} as const;
export const RUN_PATH_TYPE = {
  FORWARD_ENTRY: '1',
  FORWARD_EXIT: '2',
  BACKWARD_ENTRY: '3',
  BACKWARD_EXIT: '4',
  OTHERS: '5',
} as const;
export const RUN_PATH_STATUS_TYPE = {
  SCHEDULED: '1',
  IN_WORK: '2',
  FINISHED: '3',
} as const;
export const TERMINAL_UPDATE_TYPE = {
  PRODUCTION: '0',
  UPDATE: '1',
  REPLACE: '2',
} as const;
export const MEASUREMENT_TOOL_TYPE = { SEPTENTRIO: '1', EMLID: '2' } as const;
export const HEADLAND_RUNNING_FLG = {
  NOT_HEADLAND_RUNNING: '0',
  HEADLAND_RUNNING: '1',
} as const;
export const MEASUREMENT_POINT_MARK_TYPE = {
  CIRCLE: '1',
  SQUARE: '2',
  TRIANGLE: '3',
  CROSS: '4',
} as const;
export const TOOL_TYPE = {
  YANMAR_SPRAYER: '1',
  MECHANICAL_WEEDER_INTERCEPS: '2',
  MECHANICAL_WEEDER_INTER_ROWS: '3',
  HYDRAULIC_WEEDER_INTERCEPS: '4',
  HYDRAULIC_WEEDER_INTER_ROWS: '5',
} as const;
export const HYDRAULIC_OUTLET_PORT_TYPE = {
  NOT_FOR_USE: '1',
  USE: '2',
  R1_IN_SERIES_WITH_L: '3',
  R2_PARALLEL_WITH_L: '4',
} as const;

export interface IndexedData {
  [key: string]: string;
}

export const MIME_TYPE_NAME: IndexedData = {
  '1': 'image/apng',
  '2': 'image/bmp',
  '3': 'image/gif',
  '4': 'image/x-icon',
  '5': 'image/jpeg',
  '6': 'image/png',
  '7': 'image/svg+xml',
  '8': 'image/tiff',
  '9': 'image/webp',
} as const;

export const MAX_WORKDATE: number = 20;

export const WORK_START_TYPE_NAME = [
  { id: WORK_START_TYPE.AM, name: 'AM' },
  { id: WORK_START_TYPE.PM, name: 'PM' },
  { id: WORK_START_TYPE.ANYTIME, name: 'ANYTIME' },
  { id: WORK_START_TYPE.SPECIFY_TIME, name: 'SPECIFYTIME' },
] as const;

export const WORK_TYPE_NAME = [
  { id: WORK_TYPE.SPRAYING, name: 'SPRAYING' },
  { id: WORK_TYPE.WEEDING_INTERCEPS, name: 'WEEDINGINTERCEPS' },
  { id: WORK_TYPE.WEEDING_INTER_ROWS, name: 'WEEDINGINTERROWS' },
  // TODO:本番環境で油圧項目を選択不可とする。#13171にて削除予定
  ...(environment.production
    ? []
    : [
        {
          id: WORK_TYPE.HYDRAULIC_WEEDING_INTERCEPS,
          name: 'HYDRAULICWEEDINGINTERCEPS',
        },
        {
          id: WORK_TYPE.HYDRAULIC_WEEDING_INTER_ROWS,
          name: 'HYDRAULICWEEDINGINTERROWS',
        },
      ]),
] as const;

export const TOOL_TYPE_NAME = [
  {
    id: TOOL_TYPE.HYDRAULIC_WEEDER_INTERCEPS,
    name: 'HYDRAULICWEEDERINTERCEPS',
  },
  {
    id: TOOL_TYPE.HYDRAULIC_WEEDER_INTER_ROWS,
    name: 'HYDRAULICWEEDERINTERROWS',
  },
] as const;

export const HYDRAULIC_OUTLET_L_PORT_TYPE_NAME = [
  { id: HYDRAULIC_OUTLET_PORT_TYPE.USE, name: 'USE' },
  { id: HYDRAULIC_OUTLET_PORT_TYPE.NOT_FOR_USE, name: 'NOTFORUSE' },
] as const;

export const HYDRAULIC_OUTLET_R_PORT_TYPE_NAME = [
  {
    id: HYDRAULIC_OUTLET_PORT_TYPE.R1_IN_SERIES_WITH_L,
    name: 'R1',
  },
  {
    id: HYDRAULIC_OUTLET_PORT_TYPE.R2_PARALLEL_WITH_L,
    name: 'R2',
  },
  { id: HYDRAULIC_OUTLET_PORT_TYPE.NOT_FOR_USE, name: 'NOTFORUSE' },
] as const;

// インプルメントの作業速度用に1.5～4.0の範囲のWORK_SPEED_TYPEの名称を定義
export const IMPLEMENT_WORK_SPEED_TYPE_NAME = [
  { id: WORK_SPEED_TYPE.SPEED1_5KPH, name: '1.5' },
  { id: WORK_SPEED_TYPE.SPEED2_0KPH, name: '2.0' },
  { id: WORK_SPEED_TYPE.SPEED2_5KPH, name: '2.5' },
  { id: WORK_SPEED_TYPE.SPEED3_0KPH, name: '3.0' },
  { id: WORK_SPEED_TYPE.SPEED3_5KPH, name: '3.5' },
  { id: WORK_SPEED_TYPE.SPEED4_0KPH, name: '4.0' },
] as const;

export const WORK_START_TIME_LIST = [
  { value: '0000', time: '00:00' },
  { value: '0030', time: '00:30' },
  { value: '0100', time: '01:00' },
  { value: '0130', time: '01:30' },
  { value: '0200', time: '02:00' },
  { value: '0230', time: '02:30' },
  { value: '0300', time: '03:00' },
  { value: '0330', time: '03:30' },
  { value: '0400', time: '04:00' },
  { value: '0430', time: '04:30' },
  { value: '0500', time: '05:00' },
  { value: '0530', time: '05:30' },
  { value: '0600', time: '06:00' },
  { value: '0630', time: '06:30' },
  { value: '0700', time: '07:00' },
  { value: '0730', time: '07:30' },
  { value: '0800', time: '08:00' },
  { value: '0830', time: '08:30' },
  { value: '0900', time: '09:00' },
  { value: '0930', time: '09:30' },
  { value: '1000', time: '10:00' },
  { value: '1030', time: '10:30' },
  { value: '1100', time: '11:00' },
  { value: '1130', time: '11:30' },
  { value: '1200', time: '12:00' },
  { value: '1230', time: '12:30' },
  { value: '1300', time: '13:00' },
  { value: '1330', time: '13:30' },
  { value: '1400', time: '14:00' },
  { value: '1430', time: '14:30' },
  { value: '1500', time: '15:00' },
  { value: '1530', time: '15:30' },
  { value: '1600', time: '16:00' },
  { value: '1630', time: '16:30' },
  { value: '1700', time: '17:00' },
  { value: '1730', time: '17:30' },
  { value: '1800', time: '18:00' },
  { value: '1830', time: '18:30' },
  { value: '1900', time: '19:00' },
  { value: '1930', time: '19:30' },
  { value: '2000', time: '20:00' },
  { value: '2030', time: '20:30' },
  { value: '2100', time: '21:00' },
  { value: '2130', time: '21:30' },
  { value: '2200', time: '22:00' },
  { value: '2230', time: '22:30' },
  { value: '2300', time: '23:00' },
  { value: '2330', time: '23:30' },
] as const;

export const BIZ_DATE = 'bizdate' as const;

export const IMAGES_PATH = {
  VINEYARD_WORK_TITLE_IMAGE: './assets/images/svg_icons/VW.svg',
  VINEYARD_SERVICE_MANAGE_TITLE_IMAGE: './assets/images/svg_icons/VSM.svg',
  PLAN_ACTIVE_IMAGE: './assets/images/svg_icons/plan.svg',
  PLAN_INACTIVE_IMAGE: './assets/images/svg_icons/plan_disable.svg',
  MACHINE_ACTIVE_IMAGE: './assets/images/svg_icons/machine.svg',
  MACHINE_INACTIVE_IMAGE: './assets/images/svg_icons/machine_disable.svg',
  RETURN_IMAGE: './assets/images/svg_icons/return.svg',
  RETURN_INACTIVE_IMAGE: './assets/images/svg_icons/return_disable.svg',
  LOGOUT_IMAGE: './assets/images/svg_icons/logout.svg',
  LOGOUT_INACTIVE_IMAGE: './assets/images/svg_icons/logout_disable.svg',
  LOCATION_IMAGE: './assets/images/svg_icons/location.svg',
  LOCATION_INACTIVE_IMAGE: './assets/images/svg_icons/location_disable.svg',
  GOAL_IMAGE: './assets/images/svg_icons/goal.svg',
  START_IMAGE: './assets/images/svg_icons/start.svg',
  FIELD_ACTIVE_IMAGE: './assets/images/svg_icons/field.svg',
  FIELD_INACTIVE_IMAGE: './assets/images/svg_icons/field_disable.svg',
  EDIT_IMAGE: './assets/images/svg_icons/edit.svg',
  EDIT_INACTIVE_IMAGE: './assets/images/svg_icons/edit_disable.svg',
  CLOSE_IMAGE: './assets/images/svg_icons/close.svg',
  CLOSE_INACTIVE_IMAGE: './assets/images/svg_icons/close_disable.svg',
  ADD_IMAGE: './assets/images/svg_icons/add.svg',
  ADD_INACTIVE_IMAGE: './assets/images/svg_icons/add_disable.svg',
  PROFILE_IMAGE: './assets/images/svg_icons/profile.svg',
  DATE_ACTIVE_IMAGE: './assets/images/svg_icons/date.svg',
  DATE_INACTIVE_IMAGE: './assets/images/svg_icons/date_disable.svg',
  CANCEL: './assets/images/svg_icons/cancel.svg',
  COMPLETED: './assets/images/svg_icons/done.svg',
  PENDING: './assets/images/svg_icons/work_suspended.svg',
  NOTSTART: './assets/images/svg_icons/not_started.svg',
  IN_PROGRESS: './assets/images/svg_icons/working.svg',
  STOP_DONE: './assets/images/svg_icons/stop_done.svg',
  STOP_STOP: './assets/images/svg_icons/stop_stop.svg',
  STOP_TEMP_STOP: './assets/images/svg_icons/stop_temp_stop.svg',
  SHOW_STOP: './assets/images/svg_icons/show_stop.svg',
  HIDE_STOP: './assets/images/svg_icons/hide_stop.svg',
  NEXT: './assets/images/svg_icons/navigate_next.svg',
  NEXT_DISABLE: './assets/images/svg_icons/navigate_next_disable.svg',
  BEFORE: './assets/images/svg_icons/navigate_before.svg',
  BEFORE_DISABLE: './assets/images/svg_icons/navigate_before_disable.svg',
  CLOSE_DIALOG: './assets/images/svg_icons/close_dialog.svg',
  CLUSTER: './assets/images/svg_icons/cluster.svg',
  FIELD_MENU_ACTIVE: './assets/images/svg_icons/field_menu.svg',
  FIELD_MENU_INACTIVE: './assets/images/svg_icons/field_menu_disable.svg',
  INPLEMENTS_MENU_ACTIVE: './assets/images/svg_icons/implements_menu.svg',
  INPLEMENTS_MENU_INACTIVE:
    './assets/images/svg_icons/implements_menu_disable.svg',
  IMPLEMENT_WORK_POSITION_WIDTH:
    './assets/images/svg_icons/implement_work_position_width.svg',
  IMPLEMENT_WORK_POSITION_LENGTH:
    './assets/images/svg_icons/implement_work_position_length.svg',
  IMPLEMENT_LIFT_UP_POSITION_WIDTH:
    './assets/images/svg_icons/implement_lift_up_position_width.svg',
  IMPLEMENT_LIFT_UP_POSITION_LENGTH:
    './assets/images/svg_icons/implement_lift_up_position_length.svg',
} as const;

export const LANGUAGE = {
  FRENCH: 'fr',
  ENGLISH: 'en-US',
  JAPANESE: 'ja',
} as const;

export const PESTICIDE_AMOUNT_UNIT_AREA_LIST = [
  { value: 150 },
  { value: 160 },
  { value: 170 },
  { value: 180 },
  { value: 190 },
  { value: 200 },
  { value: 210 },
  { value: 220 },
  { value: 230 },
  { value: 240 },
  { value: 250 },
] as const;

export const USER_ACCOUNT_MENU_PATH = {
  USER_PROFILE: 'user-profile',
  USER_PASSWORD: 'user-password',
  LOGOUT: 'logout',
} as const;

// GoogleIcon
const OUTLINE_ICON_CLASSES = ['google-icon'];
const FILL_ICON_CLASSES = [...OUTLINE_ICON_CLASSES, 'fill-icon'];
/** GoogleIcon定義用リスト
 * ※GoogleIconでアイコンを追加する場合はここと、GOOGLE_ICON_MAPに追加する */
const GOOGLE_ICON_LIST = {
  MEAS_POINT_CIRCLE: '1',
  MEAS_POINT_SQUARE: '2',
  MEAS_POINT_TRIANGLE: '3',
  MEAS_POINT_CROSS: '4',
} as const;
export const GOOGLE_ICON_MAP: {
  [key: string]: {
    iconName: string; // GoogleIconで定義されているIconNameを設定
    styleClasses: readonly string[];
  };
} = {
  [GOOGLE_ICON_LIST.MEAS_POINT_CIRCLE]: {
    iconName: 'circle',
    styleClasses: FILL_ICON_CLASSES,
  },
  [GOOGLE_ICON_LIST.MEAS_POINT_SQUARE]: {
    iconName: 'square',
    styleClasses: OUTLINE_ICON_CLASSES,
  },
  [GOOGLE_ICON_LIST.MEAS_POINT_TRIANGLE]: {
    iconName: 'change_history',
    styleClasses: OUTLINE_ICON_CLASSES,
  },
  [GOOGLE_ICON_LIST.MEAS_POINT_CROSS]: {
    iconName: 'close',
    styleClasses: OUTLINE_ICON_CLASSES,
  },
} as const;

export const GOOGLE_MAPS_MAPOPTIONS: google.maps.MapOptions = {
  mapTypeId: google.maps.MapTypeId.SATELLITE,
  // GoogleMapのコントロールを表示有無のデフォルトを無しに設定。表示したいコントロールは個別にtrueを設定する。
  disableDefaultUI: true,
  zoomControl: true,
  scaleControl: true,
  fullscreenControl: true,
  gestureHandling: 'greedy',
  tilt: 0,
} as const;

export const GOOGLE_MAPS_ZOOM_DEFAULT = 18;

export const CLUSTER_MARKER_SIZE = 35;
// スタイル設定パラメタ
// TODO advancedMarkerに置き換えたときに、styles_varsのsassで置き換える
export const WHITE_COLOR = '#FFFFFF';
export const ARROW_COLOR = '#000000';
export const YANMAR_FONT = 'Yanmar';
export const STANDARD_FONT_SIZE = 16;

/** GoogleMapのPolygon,Polyline用z-index */
export const POLYS_Z_INDEX = {
  FIELD: 1,
  WORK_PATH_BACKGROUND_LINE: 2,
  WORK_PATH_LINE: 3,
  WORK_PATH_MARKER: 4,
  MEASUREMENT_POINT_MARK: 5,
} as const;
/** GoogleMapのMarker用z-index */
export const MARKER_Z_INDEX = {
  FIELD_NAME: 1,
  SELECTED_FIELD_NAME: 2,
  GOAL: 3,
  START: 4,
  MACHINE: 5,
  STOP: 6,
  SELECTED_STOP: 7,
} as const;

export const POLYLINE_TYPES = {
  DASHED: '0',
  SOLID: '1',
} as const;

export const MEASUREMENT_POINT_MARK_MAP: {
  [key: string]: measurementPointMarkData;
} = {
  [MEASUREMENT_POINT_MARK_TYPE.CIRCLE]: {
    // GoogleIconの「Circle」のpathを使用
    // https://fonts.google.com/icons?selected=Material+Symbols+Outlined:circle:FILL@1;wght@400;GRAD@0;opsz@24&icon.query=circle&icon.size=24&icon.color=%231f1f1f
    symbolPath:
      'M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z',
    symbolScale: 0.006,
    isFilledSymbol: true,
    googleIconKey: GOOGLE_ICON_LIST.MEAS_POINT_CIRCLE,
  },
  [MEASUREMENT_POINT_MARK_TYPE.SQUARE]: {
    // GoogleIconの「Square」のpathを使用
    // https://fonts.google.com/icons?selected=Material+Symbols+Outlined:square:FILL@1;wght@400;GRAD@0;opsz@24&icon.query=square&icon.size=24&icon.color=%23000000
    symbolPath: 'M120-120v-720h720v720H120Z',
    symbolScale: 0.008,
    isFilledSymbol: false,
    googleIconKey: GOOGLE_ICON_LIST.MEAS_POINT_SQUARE,
  },
  [MEASUREMENT_POINT_MARK_TYPE.TRIANGLE]: {
    // GoogleIconの「Change History」のpathを使用
    // https://fonts.google.com/icons?selected=Material+Symbols+Outlined:change_history:FILL@1;wght@400;GRAD@0;opsz@24&icon.query=Shape&icon.size=24&icon.color=%23000000
    symbolPath: 'm80-160 400-640 400 640H80Z',
    symbolScale: 0.008,
    isFilledSymbol: false,
    googleIconKey: GOOGLE_ICON_LIST.MEAS_POINT_TRIANGLE,
  },
  [MEASUREMENT_POINT_MARK_TYPE.CROSS]: {
    // GoogleIconの「Close」のpathを使用
    // https://fonts.google.com/icons?selected=Material+Symbols+Outlined:close:FILL@1;wght@400;GRAD@0;opsz@24&icon.size=24&icon.color=%23000000
    symbolPath:
      'm256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z',
    symbolScale: 0.008,
    isFilledSymbol: false,
    googleIconKey: GOOGLE_ICON_LIST.MEAS_POINT_CROSS,
  },
} as const;

export const MEASUREMENT_POINT_MARKS_COLORS: IndexedData = {
  [FIELD_MEASUREMENT_TYPE.OUT]: 'rgb(0, 81, 255)',
  [FIELD_MEASUREMENT_TYPE.PICKET]: 'rgb(255, 0, 0)',
  [FIELD_MEASUREMENT_TYPE.MIDDLE]: 'rgb(7, 248, 19)',
} as const;

/**
 * 'M/d/yy, h:mm a'の日付フォーマット 例：6/15/15, 9:03 AM
 * 参照：https://v17.angular.io/api/common/DatePipe#pre-defined-format-options
 */
export const SHORT_FORMAT = 'short';
/**
 * 'M/d/yy'の日付フォーマット 例：6/15/15
 * 参照：https://v17.angular.io/api/common/DatePipe#pre-defined-format-options
 */
export const SHORT_DATE_FORMAT = 'shortDate';
/**
 * 'MMMM d, y'の日付フォーマット 例：June 15, 2015
 * 参照：https://v17.angular.io/api/common/DatePipe#pre-defined-format-options
 */
export const LONG_DATE_FORMAT = 'longDate';
/**
 * 短い形式の時刻フォーマット
 * en：h:mm a　例：1:03 PM
 * その他：HH:mm　例：13:03
 * 参照：https://v17.angular.io/api/common/DatePipe#pre-defined-format-options
 */
export const SHORT_TIME_FORMAT = 'shortTime';

export enum TokenRefreshStatus {
  InProgress,
  Completed,
  Error,
}

/** ブラウザのズーム操作無効化用スタイルクラス名 */
export const DISABLE_ZOOM_STYLE_CLASS = 'disable-zoom';
export const CONTAINER_LAYOUT_STYLE_CLASS = 'container-layout';

/** overlayにCSSを適用するためのStyleClass */
export const overlayStyleClasses = {
  loadingSpinner: 'loading-spinner-overlay',
  messageDialog: 'message-dialog-overlay',
} as const;

export const SELECTED_COLOR = 'rgb(125, 204, 243)';

export const FILE_UPLOAD_CONTROL_NAME = 'fileUpload';

/**
 * クリップボードの設定
 * 各値の説明の参照: https://github.com/IgniteUI/igniteui-angular/wiki/Grid-clipboard-interactions#api
 */
export const CLIPBOARD_OPTIONS: IClipboardOptions = {
  // IgniteUIのセルの値のコピー機能を無効化し、ブラウザデフォルトのコピー動作にするため、enabled: falseに設定。
  enabled: false,
  // enabled以外の設定はIgniteUIのセルのコピー機能についての設定の為、
  // 　enabled: falseにより無視されるが、必須項目となっているためデフォルト値と同じ値を設定。
  copyHeaders: true,
  copyFormatters: true,
  separator: '\t',
} as const;

/** IgniteUIのIgxCombo用のアイテムリスト最大高（単位：px） */
export const COMBO_ITEMS_MAX_HEIGHT = 400;

/** ブラウザ言語コード（サポート対象言語） */
export const LOCALE_CODES = {
  EN: 'en',
  FR: 'fr',
  JA: 'ja',
};
/** DateFnsAdaptor設定用のLocale */
export const DATE_FNS_LOCALES: {
  [key: string]: Locale;
} = {
  [LOCALE_CODES.EN]: enUS,
  [LOCALE_CODES.FR]: fr,
  [LOCALE_CODES.JA]: ja,
} as const;

export const InputMode = {
  DECIMAL: 'decimal',
  NUMERIC: 'numeric',
  /** TODO input type=number をやめた後削除して、使用箇所の方を NUMERIC に置き換える */
  NUMBER: 'number',
} as const;

export const COMMA = ',';
export const PERIOD = '.';
